module.exports = __webpack_public_path__ + "static/img/home-dialog.b325269a.jpg";